import Forbidden403 from "@components/Forbiden403.tsx";
import React from "react";// Ajuste le chemin si besoin

interface AccessGuardProps {
  canAccess: boolean;
  children: React.ReactNode;
}

const AccessGuard: React.FC<AccessGuardProps> = ({ canAccess, children }) => {
  return <>{canAccess ? children : <Forbidden403 />}</>;
};

export default AccessGuard;
